/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as ExtensionConnectRouteImport } from './routes/extension/connect'
import { Route as InviteTokenRouteImport } from './routes/invite/$token'
import { Route as OnboardingWorkspaceRouteImport } from './routes/onboarding/workspace'
import { Route as ShareTokenRouteImport } from './routes/share/$token'
import { Route as WSlugRouteRouteImport } from './routes/w/$slug/route'
import { Route as WSlugIndexRouteImport } from './routes/w/$slug/index'
import { Route as WSlugGetStartedRouteImport } from './routes/w/$slug/get-started'
import { Route as WSlugInboxRouteImport } from './routes/w/$slug/inbox'
import { Route as WSlugMineRouteImport } from './routes/w/$slug/mine'
import { Route as WSlugResolvedRouteImport } from './routes/w/$slug/resolved'
import { Route as WSlugRReportKeyRouteImport } from './routes/w/$slug/r/$reportKey'
import { Route as WSlugSettingsIndexRouteImport } from './routes/w/$slug/settings/index'
import { Route as WSlugSettingsAuditRouteImport } from './routes/w/$slug/settings/audit'
import { Route as WSlugSettingsIntegrationsRouteImport } from './routes/w/$slug/settings/integrations'
import { Route as WSlugSettingsKeysRouteImport } from './routes/w/$slug/settings/keys'
import { Route as WSlugSettingsMembersRouteImport } from './routes/w/$slug/settings/members'
import { Route as WSlugSettingsPrivacyRouteImport } from './routes/w/$slug/settings/privacy'
import { Route as WSlugSettingsWorkspaceRouteImport } from './routes/w/$slug/settings/workspace'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const ExtensionConnectRoute = ExtensionConnectRouteImport.update({
  id: '/extension/connect',
  path: '/extension/connect',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingWorkspaceRoute = OnboardingWorkspaceRouteImport.update({
  id: '/onboarding/workspace',
  path: '/onboarding/workspace',
  getParentRoute: () => rootRouteImport,
} as any)
const ShareTokenRoute = ShareTokenRouteImport.update({
  id: '/share/$token',
  path: '/share/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const WSlugRouteRoute = WSlugRouteRouteImport.update({
  id: '/w/$slug',
  path: '/w/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const WSlugIndexRoute = WSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugGetStartedRoute = WSlugGetStartedRouteImport.update({
  id: '/get-started',
  path: '/get-started',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugInboxRoute = WSlugInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugMineRoute = WSlugMineRouteImport.update({
  id: '/mine',
  path: '/mine',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugResolvedRoute = WSlugResolvedRouteImport.update({
  id: '/resolved',
  path: '/resolved',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugRReportKeyRoute = WSlugRReportKeyRouteImport.update({
  id: '/r/$reportKey',
  path: '/r/$reportKey',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugSettingsIndexRoute = WSlugSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugSettingsAuditRoute = WSlugSettingsAuditRouteImport.update({
  id: '/settings/audit',
  path: '/settings/audit',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugSettingsIntegrationsRoute =
  WSlugSettingsIntegrationsRouteImport.update({
    id: '/settings/integrations',
    path: '/settings/integrations',
    getParentRoute: () => WSlugRouteRoute,
  } as any)
const WSlugSettingsKeysRoute = WSlugSettingsKeysRouteImport.update({
  id: '/settings/keys',
  path: '/settings/keys',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugSettingsMembersRoute = WSlugSettingsMembersRouteImport.update({
  id: '/settings/members',
  path: '/settings/members',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugSettingsPrivacyRoute = WSlugSettingsPrivacyRouteImport.update({
  id: '/settings/privacy',
  path: '/settings/privacy',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugSettingsWorkspaceRoute = WSlugSettingsWorkspaceRouteImport.update({
  id: '/settings/workspace',
  path: '/settings/workspace',
  getParentRoute: () => WSlugRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/w/$slug': typeof WSlugRouteRouteWithChildren
  '/extension/connect': typeof ExtensionConnectRoute
  '/invite/$token': typeof InviteTokenRoute
  '/onboarding/workspace': typeof OnboardingWorkspaceRoute
  '/share/$token': typeof ShareTokenRoute
  '/w/$slug/get-started': typeof WSlugGetStartedRoute
  '/w/$slug/inbox': typeof WSlugInboxRoute
  '/w/$slug/mine': typeof WSlugMineRoute
  '/w/$slug/resolved': typeof WSlugResolvedRoute
  '/w/$slug/': typeof WSlugIndexRoute
  '/w/$slug/r/$reportKey': typeof WSlugRReportKeyRoute
  '/w/$slug/settings/audit': typeof WSlugSettingsAuditRoute
  '/w/$slug/settings/integrations': typeof WSlugSettingsIntegrationsRoute
  '/w/$slug/settings/keys': typeof WSlugSettingsKeysRoute
  '/w/$slug/settings/members': typeof WSlugSettingsMembersRoute
  '/w/$slug/settings/privacy': typeof WSlugSettingsPrivacyRoute
  '/w/$slug/settings/workspace': typeof WSlugSettingsWorkspaceRoute
  '/w/$slug/settings/': typeof WSlugSettingsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/extension/connect': typeof ExtensionConnectRoute
  '/invite/$token': typeof InviteTokenRoute
  '/onboarding/workspace': typeof OnboardingWorkspaceRoute
  '/share/$token': typeof ShareTokenRoute
  '/w/$slug/get-started': typeof WSlugGetStartedRoute
  '/w/$slug/inbox': typeof WSlugInboxRoute
  '/w/$slug/mine': typeof WSlugMineRoute
  '/w/$slug/resolved': typeof WSlugResolvedRoute
  '/w/$slug': typeof WSlugIndexRoute
  '/w/$slug/r/$reportKey': typeof WSlugRReportKeyRoute
  '/w/$slug/settings/audit': typeof WSlugSettingsAuditRoute
  '/w/$slug/settings/integrations': typeof WSlugSettingsIntegrationsRoute
  '/w/$slug/settings/keys': typeof WSlugSettingsKeysRoute
  '/w/$slug/settings/members': typeof WSlugSettingsMembersRoute
  '/w/$slug/settings/privacy': typeof WSlugSettingsPrivacyRoute
  '/w/$slug/settings/workspace': typeof WSlugSettingsWorkspaceRoute
  '/w/$slug/settings': typeof WSlugSettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/w/$slug': typeof WSlugRouteRouteWithChildren
  '/extension/connect': typeof ExtensionConnectRoute
  '/invite/$token': typeof InviteTokenRoute
  '/onboarding/workspace': typeof OnboardingWorkspaceRoute
  '/share/$token': typeof ShareTokenRoute
  '/w/$slug/get-started': typeof WSlugGetStartedRoute
  '/w/$slug/inbox': typeof WSlugInboxRoute
  '/w/$slug/mine': typeof WSlugMineRoute
  '/w/$slug/resolved': typeof WSlugResolvedRoute
  '/w/$slug/': typeof WSlugIndexRoute
  '/w/$slug/r/$reportKey': typeof WSlugRReportKeyRoute
  '/w/$slug/settings/audit': typeof WSlugSettingsAuditRoute
  '/w/$slug/settings/integrations': typeof WSlugSettingsIntegrationsRoute
  '/w/$slug/settings/keys': typeof WSlugSettingsKeysRoute
  '/w/$slug/settings/members': typeof WSlugSettingsMembersRoute
  '/w/$slug/settings/privacy': typeof WSlugSettingsPrivacyRoute
  '/w/$slug/settings/workspace': typeof WSlugSettingsWorkspaceRoute
  '/w/$slug/settings/': typeof WSlugSettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/w/$slug'
    | '/extension/connect'
    | '/invite/$token'
    | '/onboarding/workspace'
    | '/share/$token'
    | '/w/$slug/get-started'
    | '/w/$slug/inbox'
    | '/w/$slug/mine'
    | '/w/$slug/resolved'
    | '/w/$slug/'
    | '/w/$slug/r/$reportKey'
    | '/w/$slug/settings/audit'
    | '/w/$slug/settings/integrations'
    | '/w/$slug/settings/keys'
    | '/w/$slug/settings/members'
    | '/w/$slug/settings/privacy'
    | '/w/$slug/settings/workspace'
    | '/w/$slug/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/extension/connect'
    | '/invite/$token'
    | '/onboarding/workspace'
    | '/share/$token'
    | '/w/$slug/get-started'
    | '/w/$slug/inbox'
    | '/w/$slug/mine'
    | '/w/$slug/resolved'
    | '/w/$slug'
    | '/w/$slug/r/$reportKey'
    | '/w/$slug/settings/audit'
    | '/w/$slug/settings/integrations'
    | '/w/$slug/settings/keys'
    | '/w/$slug/settings/members'
    | '/w/$slug/settings/privacy'
    | '/w/$slug/settings/workspace'
    | '/w/$slug/settings'
  id:
    | '__root__'
    | '/'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/w/$slug'
    | '/extension/connect'
    | '/invite/$token'
    | '/onboarding/workspace'
    | '/share/$token'
    | '/w/$slug/get-started'
    | '/w/$slug/inbox'
    | '/w/$slug/mine'
    | '/w/$slug/resolved'
    | '/w/$slug/'
    | '/w/$slug/r/$reportKey'
    | '/w/$slug/settings/audit'
    | '/w/$slug/settings/integrations'
    | '/w/$slug/settings/keys'
    | '/w/$slug/settings/members'
    | '/w/$slug/settings/privacy'
    | '/w/$slug/settings/workspace'
    | '/w/$slug/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignInRoute: typeof SignInRoute
  SignUpRoute: typeof SignUpRoute
  WSlugRouteRoute: typeof WSlugRouteRouteWithChildren
  ExtensionConnectRoute: typeof ExtensionConnectRoute
  InviteTokenRoute: typeof InviteTokenRoute
  OnboardingWorkspaceRoute: typeof OnboardingWorkspaceRoute
  ShareTokenRoute: typeof ShareTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/extension/connect': {
      id: '/extension/connect'
      path: '/extension/connect'
      fullPath: '/extension/connect'
      preLoaderRoute: typeof ExtensionConnectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/workspace': {
      id: '/onboarding/workspace'
      path: '/onboarding/workspace'
      fullPath: '/onboarding/workspace'
      preLoaderRoute: typeof OnboardingWorkspaceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/share/$token': {
      id: '/share/$token'
      path: '/share/$token'
      fullPath: '/share/$token'
      preLoaderRoute: typeof ShareTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$slug': {
      id: '/w/$slug'
      path: '/w/$slug'
      fullPath: '/w/$slug'
      preLoaderRoute: typeof WSlugRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$slug/': {
      id: '/w/$slug/'
      path: '/'
      fullPath: '/w/$slug/'
      preLoaderRoute: typeof WSlugIndexRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/get-started': {
      id: '/w/$slug/get-started'
      path: '/get-started'
      fullPath: '/w/$slug/get-started'
      preLoaderRoute: typeof WSlugGetStartedRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/inbox': {
      id: '/w/$slug/inbox'
      path: '/inbox'
      fullPath: '/w/$slug/inbox'
      preLoaderRoute: typeof WSlugInboxRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/mine': {
      id: '/w/$slug/mine'
      path: '/mine'
      fullPath: '/w/$slug/mine'
      preLoaderRoute: typeof WSlugMineRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/resolved': {
      id: '/w/$slug/resolved'
      path: '/resolved'
      fullPath: '/w/$slug/resolved'
      preLoaderRoute: typeof WSlugResolvedRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/r/$reportKey': {
      id: '/w/$slug/r/$reportKey'
      path: '/r/$reportKey'
      fullPath: '/w/$slug/r/$reportKey'
      preLoaderRoute: typeof WSlugRReportKeyRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/settings/': {
      id: '/w/$slug/settings/'
      path: '/settings'
      fullPath: '/w/$slug/settings/'
      preLoaderRoute: typeof WSlugSettingsIndexRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/settings/audit': {
      id: '/w/$slug/settings/audit'
      path: '/settings/audit'
      fullPath: '/w/$slug/settings/audit'
      preLoaderRoute: typeof WSlugSettingsAuditRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/settings/integrations': {
      id: '/w/$slug/settings/integrations'
      path: '/settings/integrations'
      fullPath: '/w/$slug/settings/integrations'
      preLoaderRoute: typeof WSlugSettingsIntegrationsRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/settings/keys': {
      id: '/w/$slug/settings/keys'
      path: '/settings/keys'
      fullPath: '/w/$slug/settings/keys'
      preLoaderRoute: typeof WSlugSettingsKeysRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/settings/members': {
      id: '/w/$slug/settings/members'
      path: '/settings/members'
      fullPath: '/w/$slug/settings/members'
      preLoaderRoute: typeof WSlugSettingsMembersRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/settings/privacy': {
      id: '/w/$slug/settings/privacy'
      path: '/settings/privacy'
      fullPath: '/w/$slug/settings/privacy'
      preLoaderRoute: typeof WSlugSettingsPrivacyRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/settings/workspace': {
      id: '/w/$slug/settings/workspace'
      path: '/settings/workspace'
      fullPath: '/w/$slug/settings/workspace'
      preLoaderRoute: typeof WSlugSettingsWorkspaceRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
  }
}

interface WSlugRouteRouteChildren {
  WSlugGetStartedRoute: typeof WSlugGetStartedRoute
  WSlugInboxRoute: typeof WSlugInboxRoute
  WSlugMineRoute: typeof WSlugMineRoute
  WSlugResolvedRoute: typeof WSlugResolvedRoute
  WSlugIndexRoute: typeof WSlugIndexRoute
  WSlugRReportKeyRoute: typeof WSlugRReportKeyRoute
  WSlugSettingsAuditRoute: typeof WSlugSettingsAuditRoute
  WSlugSettingsIntegrationsRoute: typeof WSlugSettingsIntegrationsRoute
  WSlugSettingsKeysRoute: typeof WSlugSettingsKeysRoute
  WSlugSettingsMembersRoute: typeof WSlugSettingsMembersRoute
  WSlugSettingsPrivacyRoute: typeof WSlugSettingsPrivacyRoute
  WSlugSettingsWorkspaceRoute: typeof WSlugSettingsWorkspaceRoute
  WSlugSettingsIndexRoute: typeof WSlugSettingsIndexRoute
}

const WSlugRouteRouteChildren: WSlugRouteRouteChildren = {
  WSlugGetStartedRoute: WSlugGetStartedRoute,
  WSlugInboxRoute: WSlugInboxRoute,
  WSlugMineRoute: WSlugMineRoute,
  WSlugResolvedRoute: WSlugResolvedRoute,
  WSlugIndexRoute: WSlugIndexRoute,
  WSlugRReportKeyRoute: WSlugRReportKeyRoute,
  WSlugSettingsAuditRoute: WSlugSettingsAuditRoute,
  WSlugSettingsIntegrationsRoute: WSlugSettingsIntegrationsRoute,
  WSlugSettingsKeysRoute: WSlugSettingsKeysRoute,
  WSlugSettingsMembersRoute: WSlugSettingsMembersRoute,
  WSlugSettingsPrivacyRoute: WSlugSettingsPrivacyRoute,
  WSlugSettingsWorkspaceRoute: WSlugSettingsWorkspaceRoute,
  WSlugSettingsIndexRoute: WSlugSettingsIndexRoute,
}

const WSlugRouteRouteWithChildren = WSlugRouteRoute._addFileChildren(
  WSlugRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignInRoute: SignInRoute,
  SignUpRoute: SignUpRoute,
  WSlugRouteRoute: WSlugRouteRouteWithChildren,
  ExtensionConnectRoute: ExtensionConnectRoute,
  InviteTokenRoute: InviteTokenRoute,
  OnboardingWorkspaceRoute: OnboardingWorkspaceRoute,
  ShareTokenRoute: ShareTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
